import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import Styles from "./index.module.css";
import Description from "./Shared/Description";
import Submissions from "./Shared/Submissions";
import { changeTab } from "../../actions/tab";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";

const LeftPanel = () => {
  const tab = useSelector((state) => state.tab.active);
  const dispatch = useDispatch();
  const { params } = useRouteMatch();
  const { problemUrl } = params;

  useEffect(() => {
    dispatch(changeTab("description"));
  }, [problemUrl, dispatch]);

  return (
    <Tabs
      activeKey={tab}
      onSelect={(k) => {
        dispatch(changeTab(k));
      }}
    >
      <Tab eventKey="description" title="Description">
        <div className={Styles.contentWrapper}>
          <Description />
        </div>
      </Tab>
      <Tab eventKey="submission" title="Submissions">
        <div className={Styles.contentWrapper}>
          <Submissions />
        </div>
      </Tab>
    </Tabs>
  );
};

export default LeftPanel;
